<template>
  <div>
    <BreadCrumbs
      :children="[
        {
          text: `Solicitud de Bonos`,
        },
      ]"
    />
    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-15">
      <div class="card-body">
        <div class="col-sm-7 mb-2">
          <input
            type="text"
            @input="filterByIdNumberCell"
            v-model="filter"
            class="form-control"
            placeholder="Filtrar por cédula, cédula"
          />
        </div>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <!-- ORDEN COMERCIOS -->

            <div class="table-wraper">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Comercio</th>
                    <th>Correo electronico</th>
                    <th>Cantidad (USD)</th>
                    <th>Cantidad (DOP)</th>
                    <th>Recibe - Nombre</th>
                    <th>Recibe - Teléfono</th>
                    <th>Stripe id</th>
                    <th>Fecha de compra</th>
                    <th class="text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="x in giftcards" :key="x.id">
                    <td>
                      {{ x.CompanyByWeb != null ? x.CompanyByWeb.Name : "" }}
                    </td>
                    <td>{{ x.User ? x.User.Email : "" }}</td>
                    <td>{{ x.Amount }}</td>
                    <td>{{ x.AmountDOP }}</td>
                    <td>{{ x.ReceiverName }}</td>
                    <td>{{ x.ReceiverPhone }}</td>
                    <td>{{ x.IdStripe }}</td>
                    <td>{{ x.createdAt | formaDate }}</td>
                    <td class="text-center">
                      <a
                        href="#"
                        @click.prevent="accetGiftCard(x)"
                        class="text-primary cursor"
                        title="Despachar"
                        ><i class="fa fa-check"></i
                      ></a>
                      <a
                        href="#"
                        @click.prevent="cancelGiftCard(x)"
                        class="text-red cursor ml-4"
                        title="cancelar"
                        ><i class="fa fa-remove"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from "../components/Breadcrumbs";
import Loader from "../components/Loader";
import { UtilsService } from "../../services/UtilsService";
import { UserService } from "../../services/UserService";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  name: "GiftCards",
  components: {
    BreadCrumbs,
    Loader,
  },
  filters: {
    formaDate(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
    },
    formaDateCreate(value) {
      if (value) {
        return moment.utc(value).format("hh:mm:ss A");
      }
    },
  },
  data() {
    return {
      utilsService: new UtilsService(),
      userService: new UserService(),
      loading: false,
      giftcards: [],
      giftCardsAll: [],
      isUsed: false,
      filter: "",
      show: true,
      giftcardsFilter: [],
      users: [],
    };
  },
  methods: {
    async accetGiftCard(giftCard) {
      Swal.fire({
        title: "Esta seguro de despachar este bono?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Guardar",
        denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.dismiss != "cancel") {
          this.loading = true;
          this.inserData(giftCard);
        }
      });
    },
    async cancelGiftCard(giftCard) {
      Swal.fire({
        title: "Esta seguro de cancelar este bono?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Cancelar",
        denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.dismiss != "cancel") {
          this.loading = true;
          this.inserDataCancel(giftCard);
        }
      });
    },
    async inserData(giftCard) {
      await this.utilsService.updateApplicationGiftCard(giftCard.Id);
      this.get();
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Se ha actualizado correctamente.",
        showConfirmButton: false,
        timer: 1500,
      });
      this.loading = false;
    },
    async inserDataCancel(giftCard) {
      try {
        await this.utilsService.cancelApplicationGiftCard(giftCard.Id);
        this.get();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Se ha cancelado correctamente.",
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", res.message, "error");
        this.loading = false;
      }
    },
    filterByIdNumberCell(event) {
      if (this.filter == "") {
        this.giftcards = this.giftcardsFilter.filter(
          (g) =>
            g.ReceiverReference.toString().includes(
              this.filter.toLowerCase()
            ) || g.ReceiverPhone.toString().includes(this.filter.toLowerCase())
        );
      }
    },
    async get() {
      this.loading = true;
      try {
        const res = await this.utilsService.getApplicationGiftCards();
        if (res.ok) {
          this.giftcards = res.data;
          this.giftcardsFilter = res.data;
        } else {
          this.$helpers.message("Error", res.message, "error");
        }
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
      }
      this.loading = false;
    },
  },

  beforeMount() {
    this.get();
  },
};
</script>

<style scoped>
tbody td {
  font-weight: 500 !important;
}
.fa {
  font-size: 1.2rem;
}
</style>
